import gerenciamentoOperadoresRoutes from '../_modules/operadores/_routes'

const GerenciamentoHome = () => import(/* webpackChunkName: "group-callcenter" */ '../_views/GerenciamentoHome')

import { permissionsManutencaoOperadores } from '../../../utils/permissionsCallCenter'

export default [
  {
    path: 'gerenciamento',
    meta: { requiresAuth: true, permissions: [...permissionsManutencaoOperadores] },
    component: GerenciamentoHome,
    children: [...gerenciamentoOperadoresRoutes],
  },
]
